module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Baking-glove-48126bab8e0cf441f29ae23909f36f37.svg";